import React, { useState, useEffect } from 'react';

import { apiUrl } from '../common/constants';
import { headersAPIObjectPublic } from '../common/utils';
import { useTranslate } from '../common/language';

import buildInfo from '../build-info.json';

export const VersionInfo = () => {
    
    const translate = useTranslate();   
    const [version, setVersion] = useState(null);

    useEffect(() => {
        
        fetch(apiUrl + '/utils/version', { headers: headersAPIObjectPublic() } ) 
        .then(res => res.json())
        .then(data => {
          setVersion(data);
        })
        .catch(err => {
          console.error('Error carregant versió', err);
        });

    }, []);

    if (!version) return null;
    
    return (
        <div style={{ textAlign: 'center', padding: 8, opacity: 0.6, fontSize: 12, marginTop: 50 }}>
            {translate('settings.version_front')}: {buildInfo.buildVersion}<br/>
            {translate('settings.version_back')}: {version.buildVersion}<br/>            
        </div>
    );
};
